export enum AppRunningModeModel {
  DEVELOPMENT = "DEVELOPMENT",
  TEST = "TEST",
  PREPROD = "PREPROD",
  STAGING = "STAGING",
  PRODUCTION = "PRODUCTION",
}
